import { encryptCardPayload } from '@greenpay_prod/crypto-internal/encrypt'

/**
 * Indica si el cifrado en origen está habilitado para esta sesión.
 * Depende del bloque `encryption` que entrega getSessionView (flag por comercio).
 */
export const isEncryptionEnabled = (encryption) =>
    Boolean(encryption && encryption.enabled && encryption.publicKey)

/**
 * Cifra SOLO el PAN y el CVV en un JWE (RSA-OAEP-256 + A256GCM) con la llave pública
 * entregada en la sesión.
 *
 * @param {object} encryption - { enabled, publicKey(JWK), kid, alg, enc, nonce }
 * @param {object} data - { number, cvv, orderId }
 * @returns {Promise<string>} JWE compact serialization (5 partes)
 */
export const encryptCardData = async (encryption, { number, cvv, orderId }) => {
    const jwk = encryption.publicKey

    const jwe = await encryptCardPayload(jwk, {
        number,
        cvv,
        orderId,
        nonce: encryption.nonce
    })

    return jwe
}
